<template>
  <div>
    <div class="table-toolbar">
      <span>{{ $t('admins.adminsNumber') }} {{ notificationsData.total }} </span>
      <div class="table-toolbar__group">
        <TableSearch :data-source="notificationsData"></TableSearch>
        <TableLimitSelector :data-source="notificationsData"></TableLimitSelector>
      </div>
    </div>
    <Table
      :columns="notificationsColumns"
      :data-source="notificationsData"
      @clickRow="() => {}"
    ></Table>
  </div>
</template>

<script>
import i18n from '@/i18n';
import utils from '@/utils/functions.js';
import Table from '@/components/Table/Table.vue';
import TableLimitSelector from '@/components/Table/TableLimitSelector.vue';
import TableSearch from '@/components/Table/TableSearch.vue';
import Column from '@/components/Table/Column';
import TableDatasource from '@/components/Table/TableDatasource.js';
import NotificationsService from '@/services/notifications.service';
import { mapState } from 'vuex';

export default {
  name: 'AdminNotifications',
  components: {
    Table,
    TableLimitSelector,
    TableSearch
  },
  data() {
    return {
      notificationsColumns: [
        new Column({
          value: 'recipient.email',
          label: 'nouns.email',
          sortable: true
        }),
        new Column({
          value: 'recipient.name',
          label: 'nouns.firstName',
          sortable: true
        }),
        new Column({
          value: 'type',
          label: 'nouns.type',
          valueParser: (type) => i18n.t(`mails.${type}`)
        }),
        new Column({
          value: 'updated_at',
          label: 'nouns.sent',
          sortable: true,
          valueParser: (updated_at) => utils.formatDate(this.userData.lang, updated_at)
        }),
        new Column({
          value: 'status',
          label: 'nouns.status',
          sortable: true
        })
      ],
      notificationsData: {}
    };
  },
  computed: {
    ...mapState({
      userData: (state) => state.profile.profileData
    })
  },
  created() {
    const adminId = this.$route.params.id;
    this.notificationsData = new TableDatasource({
      sort: 'name',
      filters: new Map().set('recipient.entityId', adminId),
      async load(props) {
        const response = await NotificationsService.fetchEmails(props);
        return response.data;
      }
    });
  }
};
</script>
